export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[600px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
          联系我们
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8">
          有建议、反馈或合作意向？欢迎随时与我们取得联系
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          <div className="bg-background-50 border border-background-200/80 rounded-xl p-5 hover:border-primary-200/60 transition-colors">
            <div className="w-10 h-10 mx-auto mb-3 bg-accent-100 rounded-xl flex items-center justify-center">
              <i className="ri-mail-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮件联系</h3>
            <p className="text-xs text-foreground-500">bakimanga@readdy.mail</p>
          </div>
          <div className="bg-background-50 border border-background-200/80 rounded-xl p-5 hover:border-primary-200/60 transition-colors">
            <div className="w-10 h-10 mx-auto mb-3 bg-secondary-100 rounded-xl flex items-center justify-center">
              <i className="ri-chat-smile-2-line text-xl text-secondary-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500">随时欢迎你的建议</p>
          </div>
          <div className="bg-background-50 border border-background-200/80 rounded-xl p-5 hover:border-primary-200/60 transition-colors">
            <div className="w-10 h-10 mx-auto mb-3 bg-primary-100 rounded-xl flex items-center justify-center">
              <i className="ri-service-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">合作咨询</h3>
            <p className="text-xs text-foreground-500">期待与您携手</p>
          </div>
        </div>
      </div>
    </section>
  );
}